import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { getPageMd } from '../../i18n/pages';
import './InfoPages.css';
import './MarkdownPage.css';

function MarkdownPage({ slug, titleKey, descriptionKey }) {
  const { i18n, t } = useTranslation();
  const lang = i18n.language;
  const content = getPageMd(slug, lang);

  if (content === null) {
    return null;
  }

  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>{t(titleKey)}</h1>
          {descriptionKey && <p>{t(descriptionKey)}</p>}
        </div>
        <div className="infoSection markdownContent">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MarkdownPage;
